// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__MnouW","item":"Accordion_item__2x1eC","opened":"Accordion_opened__YXIG1","trigger":"Accordion_trigger__FrJ7f","content":"Accordion_content__Dj3fI"};